export const Background = () => {
  return (
    <div
      className={
        "bg-map fixed left-0 top-0 -z-[2] h-screen w-screen bg-[50%_-100px] bg-repeat gradient-mask-b-60"
      }
    >
      {/* gradient */}
      <div
        className="absolute h-full w-full"
        style={{
          backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.15) 0%, rgba(2, 2, 2, 0.25) 70%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.15) 0%, rgba(2, 2, 2, 0.25) 70%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.15) 0%, rgba(2, 2, 2, 0.25) 70%)`,
        }}
      />
    </div>
  );
};
